import type { ReactNode } from 'react';

import { Avatar, Box } from '@mui/material';
import type { AvatarProps, SxProps, Theme } from '@mui/material';
import { Store } from 'lucide-react';

type AgencyLogoAvatarProps = Omit<AvatarProps, 'children' | 'variant'> & {
  logoUrl?: string | null;
  children?: ReactNode;
  fallbackSx?: SxProps<Theme>;
};

export const AgencyLogoAvatar = ({
  logoUrl,
  children,
  fallbackSx,
  ...avatarProps
}: AgencyLogoAvatarProps) => (
  <Avatar variant="rounded" {...avatarProps}>
    {logoUrl ? (
      children
    ) : (
      <Box
        sx={[
          { color: 'grey.400', display: 'flex' },
          ...(Array.isArray(fallbackSx) ? fallbackSx : [fallbackSx]),
        ]}
      >
        <Store size={36} />
      </Box>
    )}
  </Avatar>
);
